import { FullWidthLayout } from "@/layouts";
import * as Styled from "./legalPolicies";

export const LegalScreen = () => {
  return (
    <FullWidthLayout id="free-trial" bgColor="var(--background-light)">
      <Styled.LegalContainer>
        <Styled.BoxContent>
          <h1 className="headline-large weight-medium">Legal Notices</h1>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Who we are</h2>
          <p className="body-medium">
            You are accessing the website of CELLECT ENERGY (“CELLECT, the Company or us”) published online at cellectenergy.com (hereinafter the
            &quot;Website&quot;), a company domiciled at Josep Tarradellas, 8-10, 1-2 and 3, 08029 Barcelona, Spain, registered in the Barcelona Companies
            Register, “Registro Mercantil de Barcelona” Tomo 48045, folio 148, hoja B-570524, and with CIF No B67724062.
          </p>
        </Styled.BoxContent>
        <p className="body-medium">You can contact us at info@cellectenergy.com or +34 931 260 211.</p>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Intellectual and Industrial Property</h2>
          <p className="body-medium">
            All rights of intellectual property on any contents of this Web Site including, without limitation, images, trademarks, logos, distinctive signs,
            sounds and animations, texts, sound, visual and audiovisual recordings, and the databases, are owned by the Company or its licensors and are
            protected by national and international laws. Such rights are reserved in favor of the Company and / or its licensors. Any reproduction, copying,
            publication, distribution, modification, transformation, removal, handling, and any other use, with or without profit, all or part of this Web Site
            or any of its contents, without the prior express written permission of the Company is expressly prohibited. CELLECT may exercise any legal and/or
            extrajudicial actions it considers appropriate, in case of a possible violation of their rights.
          </p>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Responsibility</h2>
          <p className="body-medium">
            CELLECT is not responsible for any third-party webpages accessible from the Website; nor of the accuracy, veracity and validity of the
            Website&apos;s information that is not of its own elaboration.
          </p>
          <p className="body-medium">
            However, by virtue of article 17 of Spanish Law 34/2002, in case CELLECT is aware of the unlawfulness of such content or links, it undertakes to
            suppress or disable the links, as well as, where appropriate, blocking those contents that may be unlawful or infringe the rights of any
            third-party, in accordance with articles 11 and 16 of the mentioned Law.
          </p>
          <p className="body-medium">
            Furthermore, the Company will not be responsible for the damages that may occur due to failures or bad configurations of the browser installed by
            the user in its computer. CELLECT will not be responsible for any technical incident or failure that occurs when the user connects to the Internet.
            Likewise, the absence of interruptions or errors in accessing the website is not guaranteed.
          </p>
          <p className="body-medium">
            Likewise, CELLECT reserves the right to update, modify or delete the information contained in its website, as well as its configuration or
            presentation, at any time without assuming any responsibility for it.
          </p>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Protection of Personal Data</h2>
          <p className="body-medium">We will process your personal data according to our Privacy Policy.</p>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Cookies</h2>
          <p className="body-medium">In our Website we use cookies, please see our Cookie Policy for further details.</p>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Applicable law and jurisdiction</h2>
          <p className="body-medium">
            These Legal Notice, including our Privacy Policy and Cookie Policy, are governed by Spanish laws. The magistrates and courts of the city of
            Barcelona shall be competent to decide any controversy.
          </p>
        </Styled.BoxContent>
      </Styled.LegalContainer>
    </FullWidthLayout>
  );
};
